import { ISubmitChartAction, ISubmitChartState } from './submitChart.types'
import { SubmitChartConstants } from './submitChart.constants'

export const initialSubmitChartState: ISubmitChartState = {
  prid: '',
  emcUrl: '',
  inProgress: false,
  success: false,
  failure: false,
  responseMessage: '',
  validationMessage: [],
  lastAutoUploadDateTime: null,
  chartLockIntended: false,
  nemsisGenerationSuccessful: false,
}

export function submitChartReducer(
  state: ISubmitChartState = initialSubmitChartState,
  action: ISubmitChartAction
): ISubmitChartState {
  switch (action.type) {
    case SubmitChartConstants.SET_PRE_SUBMIT_CHART:
      return { ...state, inProgress: true, success: false, failure: false }
    case SubmitChartConstants.SET_POST_SUBMIT_CHART:
      return {
        ...state,
        ...action.submitChart,
        inProgress: false,
      }
    case SubmitChartConstants.RESET_STATE:
      return {
        prid: '',
        emcUrl: '',
        inProgress: false,
        success: false,
        failure: false,
        responseMessage: '',
        validationMessage: [],
        lastAutoUploadDateTime: null,
        chartLockIntended: false,
        nemsisGenerationSuccessful: false,
      }
    case SubmitChartConstants.SET_SUBMIT_CHART_STATE:
      return { ...state, ...action.submitChart }
    case SubmitChartConstants.SET_VALIDATION_MESSAGE:
      return {
        ...state,
        validationMessage: action.validationMessage,
      }
    default:
      return state
  }
}
